import { NodeSelectionDependencies } from '@ispm-client/modules/bpmn-modeler/service/node-selection-deps.service';
import { EventType } from '@ispm/shared/bpmn-io/bpmn-js';
import EventBus from 'diagram-js/lib/core/EventBus';
import { Store } from '@ngrx/store';
import { State } from '@ispm-client/modules/bpmn-modeler/store/state';
import {DirectUpdateBpmnModelerDataAction} from "@ispm-client/modules/bpmn-modeler/store/actions";
import { BpmnModelerConfig } from "@ispm-client/modules/bpmn-modeler/models/bpmn-modeler-config";

export class NodeSelectionDependenciesFix {

  constructor(private eventBus: EventBus,
              private elementRegistry,
              private store$: Store<State>,
              private config: BpmnModelerConfig) {
    this.eventBus.on(EventType.IMPORT_DONE, (event) => {
      const fixDependenciesMapOption = config.behavior ? config.behavior.fixDependenciesMap : null;
      const fixDependenciesMap = fixDependenciesMapOption === true && localStorage.getItem('fixDependenciesMap') === 'true';
      if (fixDependenciesMap) {
        this.updateDependenciesMap();
      }
    });
  }

  private updateDependenciesMap() {
    let dependencyMap = NodeSelectionDependencies.computeSelectionDependencyMap(this.elementRegistry);
    this.store$.dispatch(new DirectUpdateBpmnModelerDataAction({bpmnModelerData : {nodeSelectionDependencies: dependencyMap}}));
  }
}
